
<div class='loader'>
  <i class="fa fa-fw fa-circle-o-notch fa-spin fa-3x"></i>
 </div>
